module.exports = __webpack_public_path__ + "img/default-image.2ff08c69.png";